export enum EntityType {
    Job = 'Job',
    WorkOrder = 'WorkOrder',
    Code = 'Code'
}